var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestsheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0553 29.16C26.0553 30.688 24.9108 31.9255 23.4973 31.9255H7.18981C5.77781 31.9255 4.63281 30.6875 4.63281 29.16V4.22348C4.63281 2.69398 5.77831 1.45648 7.18981 1.45648H23.4973C24.9108 1.45648 26.0553 2.69398 26.0553 4.22348V29.16Z",
    fill: "#F4AE7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4493 5.2545C15.4493 5.545 14.8703 5.78 14.1593 5.78H5.92381C5.21081 5.78 4.63281 5.545 4.63281 5.2545V0.5245C4.63281 0.235 5.21031 0 5.92381 0H14.1593C14.8703 0 15.4493 0.235 15.4493 0.5245V5.2545Z",
    fill: "#F4AE7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3301 28C27.3301 29.2965 26.1741 30.345 24.7466 30.345H8.26709C6.84159 30.345 5.68359 29.296 5.68359 28V6.86502C5.68359 5.56952 6.84159 4.52002 8.26709 4.52002H24.7466C26.1741 4.52002 27.3301 5.57002 27.3301 6.86502V28Z",
    fill: "#D0D2D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3301 26.347C27.3301 27.6435 26.1741 28.692 24.7466 28.692H8.26709C6.84159 28.692 5.68359 27.643 5.68359 26.347V5.21198C5.68359 3.91648 6.84159 2.86798 8.26709 2.86798H24.7466C26.1741 2.86798 27.3301 3.91698 27.3301 5.21198V26.347Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.55 4.14001C21.55 4.29601 20.781 4.42301 19.835 4.42301H8.88497C7.93697 4.42301 7.16797 4.29601 7.16797 4.14001V1.59251C7.16797 1.43501 7.93697 1.30951 8.88497 1.30951H19.835C20.781 1.30951 21.55 1.43501 21.55 1.59251V4.14001Z",
    fill: "#D0D2D3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0345 9.01498H24.3155C25.2765 9.01498 25.2765 7.66498 24.3155 7.66498H10.0345C9.07703 7.66498 9.07703 9.01498 10.0345 9.01498ZM10.0345 11.7575H24.3155C25.2765 11.7575 25.2765 10.4085 24.3155 10.4085H10.0345C9.07703 10.4085 9.07703 11.7575 10.0345 11.7575ZM10.0345 14.56H24.3155C25.2765 14.56 25.2765 13.21 24.3155 13.21H10.0345C9.07703 13.21 9.07703 14.56 10.0345 14.56ZM10.0345 17.3H24.3155C25.2765 17.3 25.2765 15.951 24.3155 15.951H10.0345C9.07703 15.951 9.07703 17.3 10.0345 17.3ZM10.0345 22.59H16.6085C17.5665 22.59 17.5665 21.2405 16.6085 21.2405H10.0345C9.07703 21.24 9.07703 22.59 10.0345 22.59Z",
    fill: "#35494D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestsheet);
export default __webpack_public_path__ + "static/media/Testsheet.23f91ff4aebfbb561debf157a5633f92.svg";
export { ForwardRef as ReactComponent };